module.exports = __webpack_public_path__ + "img/Restaurant16.879b926a.png";